<template>
  <div>
    <wc-section-title title='Dashboard'></wc-section-title>
    <wc-page-title :title='title'></wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12' md='6'>
          <span class='headline'>Welcome to </span>
          <span class='primary--text headline font-weight-light'>CPM </span>
          <span class='info--text headline font-weight-light'>2.0</span>
          <span class='headline'>!</span>
          <br>
          <br>
          Use the "Modules" menu on the left to navigate around.
          <br>
          <br>If you are on a phone and cannot see the Modules menu, tap
          the "burger" menu <v-icon class='mx-2'>mdi-menu</v-icon> in the top left corner to open the drawer which has the Modules menu.<br>
          <br>
          Click the account icon <v-icon>mdi-account-circle</v-icon> in the top right to manager your account (contact info, password, etc)<br>
          <br>
          <h3 class='headline red--text'>Field Crews</h3>
          Head over to the "Field Crews" module to see where you have been scheduled for the day.
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'dashboard',
  computed: {
    title () {
      return moment().format('dddd MMMM D, YYYY')
    },
    today () {
      return moment().format('YYYY-MM-DD').toString()
    }
  },
  methods: {
    goToOldHub () {
      window.open('https://hub.capitalirrigation.com/#/user/dashboard')
    }
  }
}
</script>
